import React from 'react';
import { Col } from 'react-bootstrap';

import { Text } from 'v3/components';

export default function ReadOnlyField({ label, value, md = 4 }) {
  return (
    <Col md={md} xs={12} className="mb-3">
      <Text type="label" color="dark">
        {label}
      </Text>
      <Text type="regular" color="gray" as="p" className="mt-2">
        {value}
      </Text>
    </Col>
  );
}
